// This file is automatically generated. Do not edit it directly.
import { createClient, SupabaseClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://vqxumwebdjddvifcrxhb.supabase.co';
const SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_06Tmk2wJ-afKEbNoHwa3sg_NIoGs_Tq';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

let supabase: SupabaseClient;

if (SUPABASE_URL && SUPABASE_PUBLISHABLE_KEY) {
  supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'implicit',
    }
  });
} else {
  console.warn('Supabase environment variables are not set. Backend features will not work.');
  // Create a proxy that throws helpful errors instead of crashing the app
  supabase = new Proxy({} as SupabaseClient, {
    get(_, prop) {
      if (prop === 'functions') {
        return {
          invoke: () => Promise.reject(new Error('Supabase is not configured. VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY must be set.'))
        };
      }
      return undefined;
    }
  });
}

export { supabase };